/** Display metadata for the fixed content taxonomy. The id strings here must
 *  match the values written by the AI classifier. */
export const CATEGORY_META: Record<string, { label: string; hint: string; color: string }> = {
  educational: {
    label: 'Educational',
    hint: 'How-to, tutorial, explainer, listicles of tips',
    color: 'hsl(217, 91%, 60%)',
  },
  personal_story: {
    label: 'Personal story',
    hint: 'Behind-the-scenes, founder narrative, vulnerable reflection',
    color: 'hsl(330, 81%, 60%)',
  },
  promotional: {
    label: 'Promotional',
    hint: 'Product launch, sale, offer, direct CTA to buy',
    color: 'hsl(38, 92%, 50%)',
  },
  thought_leadership: {
    label: 'Thought leadership',
    hint: 'Industry insight, opinion, hot take, framework',
    color: 'hsl(262, 83%, 58%)',
  },
  social_proof: {
    label: 'Social proof',
    hint: 'Customer testimonial, case study, success story',
    color: 'hsl(142, 71%, 45%)',
  },
  announcement: {
    label: 'Announcement',
    hint: 'News, milestone, hire, fundraise, event',
    color: 'hsl(173, 58%, 39%)',
  },
  other: {
    label: 'Other',
    hint: "Doesn't fit a primary category",
    color: 'hsl(215, 16%, 47%)',
  },
}

export const CATEGORY_ORDER = [
  'educational',
  'personal_story',
  'promotional',
  'thought_leadership',
  'social_proof',
  'announcement',
  'other',
] as const
